// GamesPage.jsx
import React from 'react';

const GamesPage = () => {
    const games = [
        {
            title: "GTA 9",
            year: 2020,
            genre: "Action",
            description: "Легендарная игра с богатой кампанией и открытым миром",
            rating: 4.8,
            link: 'https://oldmelnik.itch.io/gta9pc'
        },
        {
            title: "CS MIN",
            year: 2018,
            genre: "Shooter",
            description: "Культовый тактический шутер с напряженным геймплеем",
            rating: 4.6,
            link: 'https://oldmelnik.ru/csmin.html'
        },
        {
            title: "qupe",
            year: 2019,
            genre: "Platformer",
            description: "Супер хардкорный платформер для настоящих геймеров",
            rating: 4.9,
            link: 'https://disk.yandex.ru/d/BdqUosTABzyL-A'
        },
        {
            title: "homefrigths",
            year: 2016,
            genre: "Horror",
            description: "Мрачная пародия на популярную хоррор игру",
            rating: 4.3,
            link: 'https://disk.yandex.ru/d/dzlfKytR3Wdfwj'
        },
        {
            title: "Все игры",
            link: 'https://yuriuri777.wixsite.com/oldmelnik/blank-3'
        }
    ];

    return (
        <div className="bg-white bg-opacity-10 backdrop-blur-md rounded-2xl shadow-2xl p-4 sm:p-6 lg:p-8 border border-purple-300 border-opacity-20">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-6 sm:mb-8 text-transparent bg-gradient-to-r from-purple-200 to-pink-200 bg-clip-text">Мои игры</h1>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
                {games.map((game, index) => (
                    <div key={index} className="group relative">
                        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative bg-gradient-to-br from-purple-800 to-purple-900 p-4 sm:p-6 rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
                            <div className="flex flex-col lg:flex-row space-y-4 lg:space-y-0 lg:space-x-6">
                                <div className="w-full lg:w-32 h-40 lg:h-32 bg-gradient-to-br from-purple-600 to-pink-600 rounded-xl flex items-center justify-center shadow-lg">
                                    <span className="text-5xl sm:text-6xl">🎮</span>
                                </div>
                                <div className="flex-1 space-y-3">
                                    {game.description ?
                                        <div>
                                            <h3 className="text-xl sm:text-2xl font-bold text-white mb-1">{game.title}</h3>
                                            <div className="flex flex-wrap items-center gap-2 text-xs sm:text-sm">
                                                <span className="text-purple-200">{game.year}</span>
                                                <span className="text-pink-300">•</span>
                                                <span className="text-purple-200">{game.genre}</span>
                                                <span className="text-pink-300">•</span>
                                                <div className="flex items-center">
                                                    <span className="text-yellow-400">⭐</span>
                                                    <span className="text-purple-200 ml-1">{game.rating}</span>
                                                </div>
                                            </div>
                                        </div>
                                        : 
                                        <div>
                                            <h3 className="text-xl sm:text-2xl font-bold text-white mb-1">{game.title}</h3>
                                            <div className="flex flex-wrap items-center gap-2 text-xs sm:text-sm">
                                            </div>
                                        </div>
                                    }

                                        <p className="text-purple-100 text-sm sm:text-base leading-relaxed">{game.description}</p>
                                    {game.description ?
                                        
                                        <button className="bg-gradient-to-r from-purple-500 to-pink-500
                                        text-white px-4 py-2 sm:px-6 sm:py-2.5 rounded-lg shadow-lg hover:shadow-xl 
                                        transform hover:scale-105 transition-all duration-300 text-sm sm:text-base 
                                        font-medium w-full sm:w-auto"
                                        onClick={() => window.open(game.link, '_blank')}
                                        >
                                            Играть
                                        </button>
                                        :
                                        <button className="bg-gradient-to-r from-purple-500 to-pink-500
                                        text-white px-4 py-2 sm:px-6 sm:py-2.5 rounded-lg shadow-lg hover:shadow-xl 
                                        transform hover:scale-105 transition-all duration-300 text-sm sm:text-base 
                                        font-medium w-full sm:w-auto"
                                        onClick={() => window.open(game.link, '_blank')}
                                        >
                                            Перейти
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GamesPage;